import { chartTableFlatTransformer } from '../chartTableFlatTransformer';

export const interviewsTrendTransformer = ({ response }) => {
  const { chart = [], headers, lookups } = response || {};
  const { dt, g1, g2 } = lookups || {};

  const transformedData = chartTableFlatTransformer({
    headers,
    data: chart,
    g1,
    g2,
    dt,
  });

  const categories = []; // x axis data for chart
  const series = []; // y axis data for chart

  // all available keys here are
  // interviews_completed, scorecards_filled,
  // time_to_fill_scorecard, total_interview_duration, applicants_interviewed, strong_yes, yes, strong_no, no

  // Todo: here interviews_completed key is hardcoded for now, since only that is used in the chart
  transformedData.forEach(({ dt_display, interviews_completed }) => {
    categories.push(dt_display); // Use pre-formatted month from transformer
    series.push(interviews_completed);
  });

  return {
    categories,
    series: series.every((val) => val === 0) ? [] : series,
  };
};
